module.exports = "images/11ans.4cd853ee.png";